import React, { useEffect, useState } from 'react';
import { Descriptions, Empty } from 'antd'
import Ts from './ts.png'
import styled from 'styled-components';
const Container = styled.div`
  width:100%;
  height:300px;
  background: #FFFFFF;
border-radius: 8px;
border: 1px solid #E0E4FF;
`;
const Top = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  border-radius: 8px 8px 0 0;
  background: #ECF2FF;
`;

const Image = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 8px;
  margin-left: 15px;
`;

const Text = styled.span`
font-family: MicrosoftYaHei;
font-size: 16px;
color: #333333;
`;

const Bottom = styled.div`
  display: flex;
  width: 100%;
  height: 260px;
`;

const RightSide = styled.div`
  flex: 0 0 25%;
  background: #FCFDFF;
  border-left: 1px solid #E0E4FF;
`;

const Description = styled(Descriptions)`
  width: 95%;
  
  .ant-descriptions-item {
    margin-bottom: 16px;
  }
  :where(.css-dev-only-do-not-override-n0gjrg).ant-descriptions [class^="ant-descriptions"], :where(.css-dev-only-do-not-override-n0gjrg).ant-descriptions [class*=" ant-descriptions"] {
    margin-bottom: 10px;
}
  .ant-descriptions-item-label {
    font-family: MicrosoftYaHei;
    font-size: 20px;
    color: #333333;
    line-height: 22px;
    text-align: right;
    font-style: normal;
  }

  .ant-descriptions-item-content {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 18px;
    color: #2A2B2C;
    line-height: 22px;
    text-align: left;
    font-style: normal;
  }
`;

const LeftSide = styled.div`
  flex: 0 0 75%;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const LeftItem = styled.div`
  flex: 1;
  text-align: left;
  font-size: 18px;
`;

const RightItem = styled.div`
  flex: 1;
  text-align: right;
  font-size: 18px;
  margin-right: 40px;
`;

const StyledContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 24px 20px 10px;
`;

const Lists = styled(Descriptions)`
td.ant-descriptions-item {
  padding-bottom: 5px;
}
  .ant-descriptions-item-label {
    font-size: 16px;
    color: #333333;
    line-height: 22px;
    text-align: right;
    font-style: normal;
  }

  .ant-descriptions-item-content {
    font-weight: bold;
    font-size: 16px;
    color: #2A2B2C;
    line-height: 22px;
    text-align: left;
    font-style: normal;
  }
`;

export default (props) => {
  const {
    dipDiseGrpCode,
    homeSco,
    payStandards,
    rate,
    diseType,
    medfeeSumamt,
    diseListType,
    graRootDise,
    proLosAmount,
    hifpPay,
    disbAmount,
    hifpBalance,
    hifpHosCost,
    dipDiseGrpName
  } = props.response;
  const days = props.form.getFieldsValue().act_ipt_days
  const [data, setData] = useState([]);
  const [proportion, setProportion] = useState('');

  function sortData(arr) {
    let type09 = arr.filter(item => item.medChrgitmType === "09");
    let type11 = arr.filter(item => item.medChrgitmType === "11");
    let type10 = arr.filter(item => item.medChrgitmType === "10");
    let type14 = arr.filter(item => item.medChrgitmType === "14");

    arr = arr.filter(item => !["09", "11", "10", "14"].includes(item.medChrgitmType));

    let result = [];
    if (type09.length > 0) result.push(...type09);
    if (type11.length > 0) result.push(...type11);
    if (type10.length > 0) result.push(...type10);
    result.push(...arr);
    if (type14.length > 0) result.push(...type14);

    return result;
  }

  useEffect(() => {
    if (props.response.feeStrucList) {
      // 获取 feeStrucList 数据，如果没有则使用 props.requestParam.feeStrucList
      const requestParam = props.response.feeStrucList || props.requestParam.feeStrucList;
      
      // 过滤掉 ratio 为 0 的项
      const filteredData = requestParam.filter(item => item.ratio !== 0);
      console.log(requestParam);
      // 对过滤后的数据进行排序
      let sortedData = sortData(filteredData);
      
      // 计算总比例，只考虑 medChrgitmType 为 '09', '10', '11' 的项
      let totalRatio = filteredData
        .filter(item => ['09', '10', '11'].includes(item.medChrgitmType))
        .reduce((sum, item) => sum + (item.ratio || 0), 0);
      
      // 设置过滤后的数据
      setData(sortedData);
      
      // 设置总比例值，保留整数部分
      setProportion((totalRatio * 100).toFixed(0));
    }
  }, [props]);
  
  return (
    <Container>
      <Top>
        <Image src={Ts} alt="描述" />
        <Text>预测分组：<span style={{ color: '#0A8CEB' }}>{dipDiseGrpCode}</span>
          <span>{dipDiseGrpName === '' ? '未入组' : dipDiseGrpName}</span>（标准分值：<span style={{ color: '#CE0E0E' }}>{homeSco}</span>
          ，支付标准：<span style={{ color: '#CE0E0E' }}>{payStandards}</span> 元）</Text>
      </Top>
      <Bottom>
        <LeftSide>
          <Description size="middle" column={4}>
            <Descriptions.Item label="预测倍率" contentStyle={{ marginBottom: '12px' }}>
              {rate}
            </Descriptions.Item>

            <Descriptions.Item label="报销比例" contentStyle={{ marginBottom: '12px' }}>
              {isNaN(Math.round((hifpPay / medfeeSumamt) * 10000) / 100) || !hifpPay || !medfeeSumamt
                ? 0
                : (Math.round((hifpPay / medfeeSumamt) * 10000) / 100).toFixed(2)}%
            </Descriptions.Item>

            <Descriptions.Item label="盈亏比例" contentStyle={{ marginBottom: '12px' }}>
              {isNaN(Math.round((proLosAmount / hifpPay) * 10000) / 100) || !proLosAmount || !hifpPay
                ? <span style={{ color: 'green' }}>0</span>
                : (() => {
                  const result = Math.round((proLosAmount / hifpPay) * 10000) / 100;
                  const color = result < 0 ? 'red' : 'green';
                  return <span style={{ color }}>{result.toFixed(2)}%</span>;
                })()}
            </Descriptions.Item>

            <Descriptions.Item label="分组类别" contentStyle={{ marginBottom: '12px' }}>
              {diseType}
            </Descriptions.Item>

            <Descriptions.Item labelStyle={{ marginLeft: '20px' }} label="总费用" contentStyle={{ marginBottom: '12px' }}>
              {isNaN(medfeeSumamt) || medfeeSumamt === undefined || medfeeSumamt === null
                ? '0.00'
                : medfeeSumamt.toFixed(2)}
            </Descriptions.Item>

            <Descriptions.Item label="基本统筹" contentStyle={{ marginBottom: '12px' }}>
              {isNaN(hifpPay) || hifpPay === undefined || hifpPay === null
                ? '0.00'
                : hifpPay.toFixed(2)}
            </Descriptions.Item>

            <Descriptions.Item label="盈亏金额" contentStyle={{ marginBottom: '12px' }}>
              <span style={{ color: proLosAmount < 0 ? 'red' : 'green' }}>
                {isNaN(proLosAmount) || proLosAmount === undefined || proLosAmount === null
                  ? '0.00'
                  : proLosAmount.toFixed(2)}
              </span>
            </Descriptions.Item>

            <Descriptions.Item label="病组类型" contentStyle={{ marginBottom: '12px' }}>
              {diseListType}
            </Descriptions.Item>

            <Descriptions.Item label="应拨付额" contentStyle={{ marginBottom: '12px' }}>
              {isNaN(disbAmount) || disbAmount === undefined || disbAmount === null
                ? '0.00'
                : disbAmount.toFixed(2)}
            </Descriptions.Item>

            <Descriptions.Item label="拨付差额" contentStyle={{ marginBottom: '12px' }}>
              {(isNaN(hifpBalance) || hifpBalance === undefined || hifpBalance === null)
                ? '0.00'
                : (hifpBalance).toFixed(2)}
            </Descriptions.Item>

            <Descriptions.Item label="医院成本" contentStyle={{ marginBottom: '12px' }}>
              {isNaN(hifpHosCost) || hifpHosCost === undefined || hifpHosCost === null
                ? '0.00'
                : hifpHosCost.toFixed(2)}
            </Descriptions.Item>

            <Descriptions.Item label="基层病种" contentStyle={{ marginBottom: '12px' }}>
              {graRootDise}
            </Descriptions.Item>
          </Description>
        </LeftSide>
        <RightSide>
          <StyledContainer>
            <LeftItem>药占比：{proportion || 0}%</LeftItem>
            <RightItem>住院天数：{days || 0}天</RightItem>
          </StyledContainer>
          <div style={{ borderBottom: '2px dashed rgb(225 225 225)', margin: '0 20px' }}></div>
          <div style={{
            height: 160, overflow: 'auto',
            padding: '10px',
            margin: '5px 5px 0px 19px'
          }}>
            {
              data.length > 0 ? (
                <Lists column={2}>
                  {data.map((res) => {
                    return (
                      <Descriptions.Item label={res.medChrgitmName}>
                        {((res.ratio || 0) * 100).toFixed(0)}%
                      </Descriptions.Item>
                    );
                  })}
                </Lists>
              ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )
            }
          </div>
        </RightSide>
      </Bottom>
    </Container>

  );
};

